<!-- 选择老师 -->
<template>
  <el-form-item :label="label">
    <el-select
      v-model="chargeTypeList"
      :multiple="config.multiple"
      :placeholder="placeholder"
      :clearable="clearable">
      <el-option
        v-for="item in chargeTypes"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { inject, ref } from 'vue';

export default {
  kind: 'yq-计费类型选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => [1],
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
        };
      },
    },
    label: {
      type: String,
      default: '计费类型：',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');

    let chargeTypes = ref([
      {
        id: 1,
        name: '课时计费',
      },
      {
        id: 2,
        name: '按天计费',
      },
    ]);
    if (props.config && props.config.typeList) {
      chargeTypes = ref(props.config.typeList);
    }

    let chargeTypeList;
    function reset() {
      chargeTypeList.value = props.value;
    }

    chargeTypeList = useQuery('chargeTypeList', props.value, reset);

    return {
      reset,
      chargeTypes,
      chargeTypeList,
    };
  },
};
</script>
